import type { ReactNode } from 'react'

// Home-scoped line-icons, one per pillar, in the SAME order as PILLARS in
// HomePillars.tsx. Stroke uses currentColor so the HUD card sets colour + glow.
// Decorative — each icon is aria-hidden; the pillar's <h2> is the label.
function Icon({ children }: { children: ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  )
}

export const pillarIcons: ReactNode[] = [
  // 1. Tournaments — single-elimination bracket
  <Icon>
    <path d="M4 7h4v5" />
    <path d="M4 17h4v-5" />
    <path d="M8 12h6" />
    <circle cx="16.5" cy="12" r="1.6" />
  </Icon>,
  // 2. TrueSkill ratings — radial gauge
  <Icon>
    <path d="M4 16a8 8 0 0 1 16 0" />
    <path d="M12 16l4-4" />
    <circle cx="12" cy="16" r="1.3" />
  </Icon>,
  // 3. Ladders & leagues — rails + rungs
  <Icon>
    <path d="M8 3v18M16 3v18" />
    <path d="M8 8h8M8 12h8M8 16h8" />
  </Icon>,
  // 4. Clinics & programs — coaching cone
  <Icon>
    <path d="M10 4h4l3.5 15h-11z" />
    <path d="M9 12h6" />
    <path d="M5 19h14" />
  </Icon>,
  // 5. Court bookings — calendar
  <Icon>
    <rect x="4" y="5" width="16" height="15" rx="2" />
    <path d="M4 9.5h16M8.5 3v4M15.5 3v4" />
    <circle cx="9" cy="14" r="1" />
    <circle cx="13.5" cy="14" r="1" />
  </Icon>,
  // 6. Members & community — connected triad
  <Icon>
    <circle cx="12" cy="6" r="2.2" />
    <circle cx="6" cy="17" r="2.2" />
    <circle cx="18" cy="17" r="2.2" />
    <path d="M10.6 7.7 7.4 15M13.4 7.7 16.6 15M8 17h8" />
  </Icon>,
  // 7. Marketing — megaphone
  <Icon>
    <path d="M4 10v4l9 4V6z" />
    <path d="M13 8a3 3 0 0 1 0 8" />
    <path d="M6 14v3.5" />
  </Icon>,
]
